for (const el of document.querySelectorAll(
    '.vp-block-status-messages .content-info .close'
)) {
    el.addEventListener('click', (e) => {
        e.target.closest('.content-info').remove()
    })
}
